import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const Container = styled.nav`
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem;
  background-color: #343a40 !important;

  img {
    object-fit: contain;
    height: 30px;
    margin: 5px 0;
  }

  #last {
    margin-right: 25px;
  }

  #more {
    object-fit: contain;
    height: 15px;
    margin-bottom: -4px;
  }

  #poly1 {
    margin-bottom: -7px;
  }

  #avatar {
    border-radius: 4px;
  }

  .img {
    margin-left: 20px;
  }

  .poly {
    object-fit: contain;
    height: 6.4px;
    margin-left: 7px;
  }

  @media (min-width: 992px) {
    flex-direction: row;
  }

  @media (max-width: 300px) {
    min-width: 270px;
  }
`;

export const ActionContainer = styled.div`
  display: flex;
  justify-content: space-between;
  min-width: 15rem;
  align-items: center;

  @media (max-width: 992px) {
    width: 100%;
  }
`;

export const Brand = styled(Link)`
  font-size: 1.25rem;
  color: #df0;
  border: solid;
  border-color: transparent;
  flex-grow: 0;
  padding: 0.125rem 0;

  &:focus,
  :hover {
    text-decoration: none;
    color: #fff;
  }
`;

export const MenuToggleButton = styled.button`
  padding: 1.125rem 1.5rem;
  font-size: 1.25rem;
  line-height: 1;
  background-color: transparent;
  border: 1px solid rgba(255, 255, 255, 0.125);
  border-radius: 0.25rem;
  background-image: url("data:image/svg+xml,%3csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3e%3cpath stroke='rgba(255, 255, 255, 0.5)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e");
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  background-size: 100% 100%;

  &:hover,
  :focus {
    text-decoration: none;
  }

  @media (min-width: 992px) {
    display: none;
  }
`;

export const MenuContainer = styled.div`
  display: flex;
  flex-direction: column;
  list-style: none;
  justify-content: space-between;
  flex-grow: 1;
  width: 100%;
  background-color: transparent !important;

  @media (min-width: 992px) {
    flex-direction: row;
    align-items: center;
    width: auto;
  }

  @media (max-width: 992px) {
    opacity: ${(props) => (props.open ? '1' : '0')};
    max-height: ${(props) => (props.open ? '100%' : '0')};
    border: ${(props) => (props.open ? 'solid' : 'none')};
    border-color: transparent;
    overflow: hidden;
    padding-top: ${(props) => (props.open ? '0.5rem' : '0')};
  }

  ul {
    display: flex;
    flex-direction: column;
    padding-left: 0;
    margin-bottom: 0;
    list-style: none;
    justify-content: space-between;

    @media (min-width: 992px) {
      flex-direction: row;
    }
  }
`;
